import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SwPush, SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ConfirmDialogComponent } from '@kinet-open-network/client/core/forms/ui';
import { ToastComponent, toast } from '@kinet-open-network/client/shared/ui';
import { TranslateService } from '@ngx-translate/core';
import { Translation } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { filter, interval, take } from 'rxjs';
// import * as primengLocale from '../assets/i18n/sk/primeng.json';

@Component({
  imports: [RouterModule, ToastComponent, ConfirmDialogComponent],
  selector: 'kon-root',
  template: `
    <router-outlet />
    <kon-toasts></kon-toasts>
    <kon-confirm-dialog> </kon-confirm-dialog>
  `,
})
export class AppComponent implements OnInit {
  private primeng = inject(PrimeNG);
  private translateService = inject(TranslateService);
  private swUpdate = inject(SwUpdate);
  private swPush = inject(SwPush);
  private router = inject(Router);

  ngOnInit(): void {
    this.setPrimeNgLocale();
    this.addTableFilterMatchModes();
    this.setupSwUpdate();
    this.setupPushNotificationClicks();
  }

  private setupPushNotificationClicks() {
    if (!this.swPush.isEnabled) {
      return;
    }

    this.swPush.notificationClicks.subscribe(({ notification }) => {
      const url = notification.data?.['url'];

      if (url) {
        this.router.navigateByUrl(url);
      }
    });
  }

  setPrimeNgLocale() {
    this.translateService
      .get('primeng')
      .pipe(take(1))
      .subscribe((res) => {
        this.primeng.setTranslation(res as Translation);
      });
  }

  private setupSwUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter(
            (evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY',
          ),
        )
        .subscribe(() =>
          toast({
            summary: 'Je dostupná nová verzia aplikácie.',
            sticky: true,
            severity: 'info',
            closable: false,
            actions: [
              {
                label: 'Aktualizovať',
                command: (message) => {
                  document.location.reload();
                },
              },
            ],
          }),
        );
      interval(2 * 60000).subscribe(() => this.swUpdate.checkForUpdate());
    }
  }

  private addTableFilterMatchModes() {
    this.primeng.filterMatchModeOptions.date.push('present');
    this.primeng.filterMatchModeOptions.text.push('present');
    this.primeng.filterMatchModeOptions.numeric.push('present');
  }
}
